module.exports = __webpack_public_path__ + "static/media/status-warning.c8d51796.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/status-warning.svg
// module id = 122
// module chunks = 0